import type { RootStore } from "~redux/store";
import { injectStore as injectHubStore } from "~/eramHubConnection";

export const injectStore = (store: RootStore) => {
  void injectHubStore(store);
};
